module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avaliacao-termo-aceite"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box pa-3"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n      Atenção candidato!"), _c('br'), _vm._v("\n      Leia o aceite abaixo para prosseguir com a realização da avaliação.\n\n      "), _c('v-divider', {
    staticClass: "my-3"
  }), _vm._v("\n\n      Estou ciente que durante a realização da prova não poderei fazer uso\n      de materiais de consulta (livros, sites, etc.) e que não poderei compartilhar o link recebido\n      com outras pessoas, sob risco de eliminação do processo seletivo.\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('v-checkbox', {
    staticClass: "justify-center",
    attrs: {
      "color": "primary",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "black--text"
        }, [_c('strong', [_vm._v("Li e concordo com os termos")])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.aceite),
      callback: function($$v) {
        _vm.aceite = $$v
      },
      expression: "aceite"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "my-0",
    attrs: {
      "color": "primary",
      "depressed": "",
      "large": "",
      "block": "",
      "disabled": !_vm.aceite
    },
    on: {
      "click": function($event) {
        return _vm.continuar()
      }
    }
  }, [_vm._v("\n        Realizar avaliação\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "page-header-content"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("Termo de aceite")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b69085f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/avaliacao/components/TermoAceite.vue
// module id = 557
// module chunks = 2